



import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class VerifyEmailPage extends Vue {

  created() {
    this.$http.get(this.$route.query.queryURL)
      .then(r => {
        this.$user.hasVerifiedEmail = true
        this.$router.push({ name: 'Home' })
        if (this.$isAuthenticated) {
          this.$eventBus.$emit('snackbar', { text: 'Email verified!' })
        } else {
          this.$eventBus.$emit('snackbar', { text: 'Email verified!' })
          this.$router.push({ name: 'Login' })
        }
      })
      .catch(err => {
        this.$eventBus.$emit('snackbar', { text: 'Something went wrong. Please try again.' })
        this.$router.push({ name: 'Home' })
      })
  }
}

